import { ALERT_FRAGMENT } from 'features/alerts/api/fragments/alert'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { WorkspaceForTableDTO } from './types'

export const WORKSPACE_FOR_TABLE_FRAGMENT: TypedDocumentNode<WorkspaceForTableDTO> = gql`
  ${ALERT_FRAGMENT}

  fragment WorkspaceForTableFragment on Workspace {
    id
    active
    alerts {
      ...AlertFragment
    }
    crmId
    domains {
      id
      alerts {
        ...AlertFragment
      }
      name
    }
    name
    networkCode
    pipedriveLink
    updatedAt
  }
`
